module.exports = __webpack_public_path__ + "img/dcbLog.454006d7.png";